document.addEventListener('DOMContentLoaded', function () {
  const SEL = {
    block: '#v5ScrollProductFeatures',
    secondPage: '.second-page-content',
    pageContent: '.page-content',
    v5MainProduct: '.section-v5-main-product',
    sectionV5PdpVariantCompare: '.section-v5-pdp-variant-compare',
    v5PdpComparison: '.v5-pdp-comparison',
    v5PdpScrollPicText: '.v5-pdp-scroll-pic-text',
    v5_diy: 'v5-diy-main',
    v5PdpBundledSale: '.section-v5-pdp-bundled-sale',
  };

  class V5ScrollProductFeatures {
    constructor() {
      this.blockId = SEL.block;
      this.v5ScrollProductFeaturesTrigger = null;
      this.secondPageContent = null;

      // 交互与状态
      this._clickLock = false;
      this.lastIndex = 1;
      this._mbClickHandler = null;
      this._mbScrollHandler = null;

      // 观察与时间线
      this._cleanupObserver = null;
      this.tl = null;
      this._refreshQueued = false;
      this._isRefreshing = false;
      this._stEventsBound = false;

      this.init();
    }

    init() {
      // 静态一次性判定，不动态监听视窗变化
      if (window.innerWidth < 1024) {
        this.secondPageContent = document.querySelector(SEL.secondPage);
        this.mbEvent();
        this.mbScrollListener();
      } else {
        this.scrollTimeLine();
        this.observeFunc();
      }
    }

    mbEvent() {
      const v5ScrollProductFeatures = document.querySelector(this.blockId);
      v5ScrollProductFeatures.style.setProperty('min-height', v5ScrollProductFeatures.offsetHeight + 'px');

      // 移动端点击切换（委托 + 点击锁），逻辑简化但保留原行为
      this._clickLock = false;

      const pcSelector = SEL.pageContent;
      const getActive = () => v5ScrollProductFeatures.querySelector(`${SEL.pageContent}.mb-active`);

      this._mbClickHandler = (e) => {
        const targetItem = e.target.closest(pcSelector);
        if (!targetItem || this._clickLock || targetItem.classList.contains('mb-active')) return;

        const currIndex = parseInt(targetItem.dataset.index || '1', 10);
        if (Number.isNaN(currIndex)) return;

        const activeEl = getActive();
        const isForward = currIndex === this.lastIndex + 1;

        this._clickLock = true;

        // 关闭当前激活项（若有）
        if (activeEl) {
          activeEl.classList.remove('show', 'mb-active');
          activeEl.classList.toggle('mb-active-leave', isForward);
        }

        // 回退时清理所有离场类，避免残留
        if (!isForward) {
          v5ScrollProductFeatures.querySelectorAll('.mb-active-leave').forEach(el => el.classList.remove('mb-active-leave'));
        }

        // 防御性：确保只保留一个激活项
        v5ScrollProductFeatures.querySelectorAll(`${SEL.pageContent}.mb-active`).forEach(el => {
          if (el !== targetItem) el.classList.remove('show', 'mb-active');
        });

        // 激活目标项
        targetItem.classList.remove('mb-active-leave');
        targetItem.classList.add('show', 'mb-active');
        this.lastIndex = currIndex;

        // 释放点击锁：动画/过渡结束 + 兜底超时
        const transitionTarget = activeEl || targetItem;
        const unlock = () => { this._clickLock = false; };
        transitionTarget.addEventListener('transitionend', unlock, { once: true });
        transitionTarget.addEventListener('animationend', unlock, { once: true });
        setTimeout(unlock, 300);
      };
      v5ScrollProductFeatures.addEventListener('click', this._mbClickHandler);

    }

    mbScrollListener() {
      const el = this.secondPageContent;
      let lastViewportState = null;
      const applyState = (isIn) => {
        if (lastViewportState === isIn) return;
        lastViewportState = isIn;
        if (isIn) {
          el.classList.add('mb-active');
        }
      };

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target !== el) continue;
          applyState(entry.isIntersecting);
          if (entry.isIntersecting) observer.unobserve(el);
        }
      }, { root: null, rootMargin: '0px 0px 20% 0px', threshold: 0 });
      observer.observe(el);

      const isIn = (() => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        return rect.top < vh && rect.bottom > 0 && rect.left < vw && rect.right > 0;
      })();
      applyState(isIn);
      this._mbScrollHandler = () => observer.unobserve(el);
    }

    observeFunc() {
      const self = this;
      const v5ScrollProductFeatures = document.querySelector(this.blockId);

      // 持续监听的关联组件类名或 唯一的DOM元素标签
      const moreCompatibleComponents = v5ScrollProductFeatures.dataset.moreCompatibleComponents;
      const moreCompatibleComponentSet = new Set();
      if (moreCompatibleComponents) {
        for (const component of moreCompatibleComponents.split(',')) {
          const selector = component.trim();
          if (!selector) continue;
          const compatibleComponent = document.querySelector(selector);
          if (compatibleComponent) moreCompatibleComponentSet.add(compatibleComponent);
        }
      }
      const moreCompatibleComponentEls = Array.from(moreCompatibleComponentSet);
      const hasMoreCompatibleComponent = moreCompatibleComponentEls.length > 0;

      // 监听一次的关联组件类名或 唯一的DOM元素标签
      const singleCompatibleComponents = v5ScrollProductFeatures.dataset.singleCompatibleComponents;
      const singleCompatibleComponentSet = new Set();
      if (singleCompatibleComponents) {
        for (const component of singleCompatibleComponents.split(',')) {
          const selector = component.trim();
          if (!selector) continue;
          const compatibleComponent = document.querySelector(selector);
          if (compatibleComponent) singleCompatibleComponentSet.add(compatibleComponent);
        }
      }
      const singleCompatibleComponentEls = Array.from(singleCompatibleComponentSet);
      const hasSingleCompatibleComponent = singleCompatibleComponentEls.length > 0;
      
      // 橱窗版块的DOM元素
      const v5MainProductContainer = document.querySelector(SEL.v5MainProduct) || document.querySelector('.product-info-container');

      // V5-变体对比
      const V5PdpVariantCompare = document.querySelector(SEL.sectionV5PdpVariantCompare);

      // V5 - 产品对比
      const V5PdpComparison = document.querySelector(SEL.v5PdpComparison);

      // V5 - 产品对比图片文字  该组件需要持续监听
      const V5PdpScrollPicText = document.querySelector(SEL.v5PdpScrollPicText);

      // v5 - diy
      const v5_diy = document.querySelector(SEL.v5_diy);

      // V5 - 捆绑销售 该组件需要持续监听
      const V5PdpBundledSale = document.querySelector(SEL.v5PdpBundledSale);

      if (v5MainProductContainer || V5PdpVariantCompare || V5PdpComparison || V5PdpScrollPicText || V5PdpBundledSale || v5_diy || hasMoreCompatibleComponent || hasSingleCompatibleComponent) {
        // 创建防抖函数来限制refresh频率
        const debouncedRefresh = window.throttle(() => {
          if (self.v5ScrollProductFeaturesTrigger) {
            self.queueRefresh();
          }
          // 观察到变更后，启动/重置空闲期清理计时器
          if (V5PdpVariantCompare || V5PdpComparison || hasSingleCompatibleComponent) {
            scheduleIdleCleanup();
          }
        }, 100); // 100ms内最多执行一次

        // 创建ResizeObserver实例
        const observer = new ResizeObserver((entries) => {
          // 检查是否有实际的尺寸变化
          for (let entry of entries) {
            const { height } = entry.contentRect;
            // 只有当尺寸发生实际变化时才触发刷新
            if (height > 0) {
              debouncedRefresh();
              break;
            }
          }
        });

        // 在一段"空闲期"后自动清理，避免过早地 load 时断开监听
        let resizeIdleTimer = null;
        const scheduleIdleCleanup = () => {
          if (resizeIdleTimer) clearTimeout(resizeIdleTimer);
          resizeIdleTimer = setTimeout(() => {
            // 橱窗稳定，卸载监听
            cleanupObserver();
          }, 120000); // 2min，根据需要调整空闲期时长
        };

        // 开始观察元素尺寸变化
        [
          v5MainProductContainer,
          V5PdpVariantCompare,
          V5PdpComparison,
          V5PdpScrollPicText,
          V5PdpBundledSale,
          v5_diy,
          ...moreCompatibleComponentEls,
          ...singleCompatibleComponentEls,
        ].forEach(element => {
          if (element) {
            observer.observe(element);
          }
        });

        // 断开观察
        const cleanupObserver = () => {
          if (observer) {
            observer.disconnect();
          }
          if (resizeIdleTimer) {
            clearTimeout(resizeIdleTimer);
            resizeIdleTimer = null;
          }
        };

        // 在页面隐藏或离开时清理，避免遗漏 load 之后生成的 DOM
        window.addEventListener('pagehide', cleanupObserver);
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') cleanupObserver();
        });

        // 清理保障：当组件卸载时也应该断开观察
        if (window.Shopify && window.Shopify.designMode && this.section) {
          const parentSection = this.section.closest('.shopify-section');
          if (parentSection) {
            parentSection.addEventListener('section:unload', cleanupObserver);
          }
        }
        // 暴露清理方法，便于销毁时调用
        this._cleanupObserver = cleanupObserver;
        return cleanupObserver;
      } else {
        this._cleanupObserver = null;
        return null;
      }
    }

    // 滚动动画
    scrollTimeLine() {
      if (!window._scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window._scrollTriggerRegistered = true;
      }

      const self = this;

      let topH = '4.1666667vw';
      const productTabsBox = document.querySelector('.blocks-nav-main') || document.querySelector('.section-navigation');
      if (productTabsBox) {
        topH = productTabsBox.offsetHeight + 'px';
      } else {
        const header = document.querySelector('jky-header,header-v5');
        topH = header.offsetHeight + 'px';
      }

      const prevTime = this.tl ? this.tl.time() : 0;
      if (self.v5ScrollProductFeaturesTrigger && typeof self.v5ScrollProductFeaturesTrigger.kill === 'function') {
        self.v5ScrollProductFeaturesTrigger.kill();
      }
      if (this.tl) {
        this.tl.kill();
      }

      this.tl = window.gsap.timeline({ paused: true });
      self.v5ScrollProductFeaturesTrigger = window.ScrollTrigger.create({
        trigger: this.blockId,
        pin: true,
        pinSpacing: true,
        start: `top ${topH}`,
        end: `+100%`,
        anticipatePin: 1,
        scrub: 1,
        smoothChildTiming: true,
        snap: {
          snapTo: 'labels',
          delay: 0.2,
          duration: { min: 0.2, max: 3 },
          ease: 'power2.inOut',
        },
        // markers: true,
        animation: this.tl,
        invalidateOnRefresh: true,
      });

      if (!this._stEventsBound) {
        window.ScrollTrigger.addEventListener('refreshInit', () => { this._isRefreshing = true; });
        window.ScrollTrigger.addEventListener('refresh', () => { this._isRefreshing = false; });
        window.ScrollTrigger.addEventListener('scrollEnd', () => {
          if (this._refreshQueued && !(this.tl && this.tl.isActive())) {
            this._refreshQueued = false;
            if (this.v5ScrollProductFeaturesTrigger && typeof this.v5ScrollProductFeaturesTrigger.refresh === 'function') {
              this.v5ScrollProductFeaturesTrigger.refresh();
            }
          }
        });
        this._stEventsBound = true;
      }

      const firstPageContent = document.querySelector('#v5ScrollProductFeatures .first-page-content');
      this.tl.addLabel('start')
        .to('#v5ScrollProductFeatures .first-page-content', {
          ease: 'power3.inOut',
          opacity: 1,
          duration: 0.4,
          onUpdate: () => {
            if (!firstPageContent.classList.contains('active')) {
              firstPageContent.classList.add('active');
            }
          }
        })

        .addLabel('first')
        .to('#v5ScrollProductFeatures .first-page-content', {
          y: '-37.5rem',
          ease: 'power3.inOut',
          opacity: 0,
          duration: 0.4,
        }, 'first')
        .to('#v5ScrollProductFeatures .second-page-content', {
          y: '-37.5rem',
          ease: 'power3.inOut',
          opacity: 1,
          duration: 0.4,
        }, 'first')

        .addLabel('second')
        .to('#v5ScrollProductFeatures .second-page-content', {
          y: '-75rem',
          ease: 'power3.inOut',
          opacity: 0,
          duration: 0.4,
        }, 'second')
        .to('#v5ScrollProductFeatures .third-page-content', {
          y: '-37.5rem',
          ease: 'power3.inOut',
          opacity: 1,
          duration: 0.4,
        }, 'second')

        .addLabel('third')
        .to('#v5ScrollProductFeatures .third-page-content', {
          y: '-75rem',
          ease: 'power3.inOut',
          opacity: 0,
          duration: 0.4,
        }, 'third')
        .to('#v5ScrollProductFeatures .fourth-page-content', {
          y: '-37.5rem',
          ease: 'power3.inOut',
          opacity: 1,
          duration: 0.4,
        }, 'third')
        .to('#v5ScrollProductFeatures .all-line', {
          bottom: '16rem',
          ease: 'power3.inOut',
          duration: 0.4,
        }, 'third')

        .addLabel('end');
      if (prevTime > 0) {
        this.tl.time(prevTime);
      }
    }

    queueRefresh() {
      if (!this.v5ScrollProductFeaturesTrigger || typeof this.v5ScrollProductFeaturesTrigger.refresh !== 'function') return;
      if ((this.tl && this.tl.isActive()) || this._isRefreshing) {
        this._refreshQueued = true;
        return;
      }
      this.v5ScrollProductFeaturesTrigger.refresh();
    }
  }
  new V5ScrollProductFeatures();
});
